import { Query } from '../../utils/network/query';
import { Picture, PictureForm } from './picture';

export const PictureTypes = [
    'PICTURE',
    'LOGO',
    'HOTEL',
    'FLIGHTPAGE',
    'HOMEPAGE',
    'DEFAULT_EXCURSIONS',
    'DEFAULT_INSURANCES',
    'DEFAULT_TRANSFERS',
    'DEFAULT_TRAINS',
    'MANUAL_PRODUCT'
] as const;

export type PictureType = typeof PictureTypes[number];

export type PictureState = {
    adding: boolean,
    alt: string,
    count: number,
    create: boolean,
    create_tab: 0 | 1,
    create_alt: string | null,
    create_credit: string | null,
    create_description: string | null,
    create_name: string | null,
    create_picture_category: number | null,
    create_name_locales: Record<number, string>,
    initial_create_name_locales: Record<number, string>,
    create_type: PictureType,
    credits: string,
    cropper: any,
    description: string,
    description_error: string,
    filter_is_active: boolean | undefined,
    filter_open: boolean,
    filter_types: PictureType[],
    files: any[],
    keep: boolean,
    limit: number,
    list: Picture[] | null,
    name: string,
    name_locales: Record<number, string>,
    initial_name_locales: Record<number, string>,
    name_error: string,
    page: number,
    picture: null | Picture,
    progress: number,
    queries: {
        key: string,
        query: Query<any>
    }[],
    refresh: boolean,
    running: boolean,
    search: string,
    selection: Picture[];
    pictures_form: PictureForm[],
};